// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/devanfarrell/GitHub/devan.us/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-blog-js": () => import("/Users/devanfarrell/GitHub/devan.us/src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */),
  "component---src-pages-index-js": () => import("/Users/devanfarrell/GitHub/devan.us/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/Users/devanfarrell/GitHub/devan.us/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

